<template>
  <div>
    <fo-header
      selected="/practice"
      @selected="(e) => {}">
    </fo-header>
    <div v-if="!modelData" class="example3">
      <a-spin />
    </div>
    <div v-else class="practice-page">
      <div class="practice-menu-layout" v-if="!$route.params.param">
        <fo-layout style="padding: 0">
          <ul class="menu-list">
            <template v-for="(item, ind) in modelData">
              <li :key="ind" :class="{'sele' : $route.params.pages === item.model_name[0]}"
                @click="$router.push('/practice/' + item.model_name[0])">{{item.title}}</li>
            </template>
          </ul>
        </fo-layout>
      </div>
      <template v-for="(item, ind) in modelData">
        <div class="practice-pages-layout" :key="ind" v-if="$route.params.pages === item.model_name[0]">
          <component
            v-show="!$route.params.param"
            v-bind:is="item.model_name[0]">
          </component>
          <component
            v-if="$route.params.param"
            v-bind:is="item.model_name[1]">
          </component>
        </div>
      </template>
    </div>
    <fo-footer></fo-footer>
  </div>
</template>

<script>
import industries from './Models/industries.vue'
import industriesDtl from './Models/industriesDtl.vue'
import areas from './Models/areas.vue'
import areasDtl from './Models/areasDtl.vue'
import cases from './Models/casesAll.vue'
import casesDtl from './Models/casesDtl.vue'
import publication from './Models/publication.vue'
import publicationDtl from './Models/publicationDtl.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    industries,
    industriesDtl,
    areas,
    areasDtl,
    cases,
    casesDtl,
    publication,
    publicationDtl
  },
  computed: mapGetters([
    'commonData'
  ]),
  data () {
    return {
      headlineText: [],
      modelData: [
        {
          title: 'Industries',
          sub_title: 'Industries',
          model_name: ['industries', 'industriesDtl'],
          visible: true
        // }, {
        //   title: 'Areas',
        //   sub_title: 'Areas',
        //   model_name: ['areas', 'areasDtl'],
        //   visible: true
        // }, {
        //   title: 'Notable Cases',
        //   sub_title: 'Notable Cases',
        //   model_name: ['cases', 'casesDtl'],
        //   visible: true
        // }, {
        //   title: 'Publication',
        //   sub_title: 'Publication',
        //   model_name: ['publication', 'publicationDtl'],
        //   visible: true
        }
      ]
    }
  },
  watch: {
    'commonData.web_pages' (obj) {
      const page = JSON.parse(obj.value).filter(item => this.$route.path.indexOf(item.value) >= 0)
      if (page.length) {
        this.modelData = page[0].children.filter(model => model.visible)
      }
    }
  },
  mounted () {
    this.headlineItems()
    // if (this.commonData.web_comp_intro.value) {
    //   const page = JSON.parse(this.commonData.web_pages.value).filter(item => this.$route.path.indexOf(item.value) >= 0)
    //   if (page.length) {
    //     this.modelData = page[0].children.filter(model => model.visible)
    //   }
    // }
  },
  methods: {
    /**
     * 页头、页脚公用信息查询
     */
    headlineItems () {
      this.get({
        url: 'configFind',
        data: {
          key: 'web_pages'
        }
      }, (r) => {
        if (r.code) {
          var data = JSON.parse(r.data.value)
          for (var i of data) {
            if (i.label_en === 'Practices' || i.label_zh === '业务范围') {
              this.modelData = i.children
            }
          }
        } else {
          this.error(r.msg)
        }
      })
    }
  }
}
</script>

<style lang="less">
@import url('../utils/color.less');
@media screen and (max-width: 751px) and (min-width: 300px) {
  .practice-page {
    .practice-menu-layout {
      /* 修改框架下边距 */
      .fo-layout-mode {
        padding-bottom: 0;
      }
      .menu-list {
        overflow: auto;
        border-bottom: 1px solid @primary;
        margin: 0;
        white-space: nowrap;
        li {
          display: inline-block;
          width: 160px;
          height: 50px;
          line-height: 50px;
          list-style-type: none;
          text-align: center;
          font-size: 16px;
          cursor: pointer;
          -webkit-user-select: none;
          -moz-user-select: none;
        }
        li:hover,
        li.sele {
          background: @primary;
          color: #FFF;
        }
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .practice-page {
    .practice-menu-layout {
      /* 修改框架下边距 */
      .fo-layout-mode {
        padding-bottom: 0;
      }
      .menu-list {
        overflow: hidden;
        border-bottom: 1px solid @primary;
        margin: 0;
        li {
          float: left;
          width: 160px;
          height: 50px;
          line-height: 50px;
          list-style-type: none;
          text-align: center;
          font-size: 16px;
          cursor: pointer;
          -webkit-user-select: none;
          -moz-user-select: none;
        }
        li:hover,
        li.sele {
          background: @primary;
          color: #FFF;
        }
      }
    }
    .practice-pages-layout {
      .fo-layout-mode {
        padding: 60px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Practice.vue